// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import cleanCallsignCascadeSegmentEndData from './cleanCallsignCascadeSegmentEndData'

const reduceCallsignCascadeData = (matches, withinBulkEdit) => {
  // this is the cleaned up data for presenting to the UI.
  // values are formatted and boiled down to only that which we need.
  const callsignCascadeData = []

  // this will be the redux-form initialValues object
  // it represents the minimum information to POST for the cascade to flow
  const callsignCascadeInput = []

  matches.forEach(d => {
    // if there are no matches here, then we can simply ignore this aggregate
    // as there are no sites to review and cascade down to.
    if (d.matches.length === 0) {
      return
    }

    callsignCascadeInput.push({
      // these values are what are submitted to the API when the redux-form is submitted.
      // this one will have the segmentEndIds which we want to cascade down to (user specified)
      matchedSegmentEndIds: [],
      // and this is the source of the cascade data for the selected above (static)
      triggeredSegmentEndId: d.callSignCascadeAggregateSegmentEnd.segmentEndId,
    })

    callsignCascadeData.push({
      // these values are for display purposes in the modal via redux-form
      callSignCascadeAggregateSegmentEnd: cleanCallsignCascadeSegmentEndData(d.callSignCascadeAggregateSegmentEnd, withinBulkEdit),
      matches: d.matches.map(dd => cleanCallsignCascadeSegmentEndData(dd)),
    })
  })

  return {
    callsignCascadeData,
    callsignCascadeInput,
  }
}

export default reduceCallsignCascadeData
